import React from "react";

export const Footer = (props) => {
  return (
    <div id="about">
      <div id="footer">
      <div className="container text-center">
        <p id="call">
          &copy; @2024 Atise Assist, atise assist Empresa   <a id="acall"href="https://www.linkedin.com/in/gleison-silveira-de-freitas-04385022b/" rel="nofollow">
            Desenvolvimento e Design por Gleison Silveira | 888h4ck.com
          </a>
        </p>
      </div>
      </div>
    </div>
    
  );
};
